import { createFileRoute } from '@tanstack/react-router';
import { PurchaseOptions } from '../components/marketing/PurchaseOptions.tsx';
import { FlowActionBar } from '../components/shell/FlowActionBar.tsx';

// The in-app paywall. Same PurchaseOptions block as the cold funnel
// (/start/paywall), but rendered inside AppShell so a user who taps an unlock
// CTA keeps their sidebar and context instead of dropping into the exit-less
// funnel chrome.
export const Route = createFileRoute('/_app/unlock')({
  component: UnlockPage,
});

function UnlockPage() {
  return (
    <>
      <FlowActionBar back={{ to: '/dashboard', label: 'Back to dashboard' }} />
      <div className="mx-auto max-w-md space-y-8 px-6 pb-28 pt-6">
        <header className="space-y-3 text-center">
          <p className="font-mono text-xs uppercase tracking-[0.32em] text-aurora">Unlock</p>
          <h1 className="font-display text-3xl text-ink-0">Unlock your full stability</h1>
          <p className="text-pretty text-ink-1">
            Keep your read, follow your protocol, and reach the energy range your system can
            maintain with consistent sessions.
          </p>
        </header>

        <PurchaseOptions />
      </div>
    </>
  );
}
